/**
 * Logical marketing paths for routing helpers (nav, footer, 404).
 * Locale-prefixed URLs are normalized via {@link toLogicalPathname} first.
 */
import { ROUTABLE_SERVICE_PAGE_TAGS } from "@/lib/i18n/paths";
import { buildLogicalEnglishPathFromRoute, toLogicalPathname } from "@/lib/i18n/paths";
import { getServiceRouteByTag as getServiceByTag } from "@/lib/i18n/routing-catalog";

import { SERVICE_DARK_HERO_PATHS } from "@/lib/cc-nav-route-constants";

export function normalizeLogicalPathname(pathname: string): string {
  const logical = toLogicalPathname(pathname);
  return logical === pathname ? pathname : logical;
}

function matchesRoutableServiceLogicalPath(path: string): boolean {
  for (const tag of ROUTABLE_SERVICE_PAGE_TAGS) {
    const service = getServiceByTag(tag);
    if (!service) {
      continue;
    }
    const hub = buildLogicalEnglishPathFromRoute({ kind: "service", serviceTag: tag });
    if (path === hub || path.startsWith(`${hub}/`)) {
      return true;
    }
  }
  return false;
}

/** Paths that render a real app page (not `not-found`). */
export function isKnownSitePath(pathname: string): boolean {
  const path = normalizeLogicalPathname(pathname);

  if (path === "/" || pathname.startsWith("/dev")) {
    return true;
  }

  if (
    path === "/about" ||
    path === "/contact" ||
    path === "/privacy-policy"
  ) {
    return true;
  }

  if (path === "/blog" || path.startsWith("/blog/")) {
    return true;
  }

  if (path === "/projects" || path.startsWith("/projects/")) {
    return true;
  }

  if (path === "/services" || path.startsWith("/services/")) {
    return true;
  }

  if (matchesRoutableServiceLogicalPath(path)) {
    return true;
  }

  return SERVICE_DARK_HERO_PATHS.some((p) => path === p);
}
